import React, { Component } from 'react';
import Slider from 'react-slick';
import '../common/index.scss';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { getProductDetail, getProductAddnInfo,getAdditionalProductDetail } from '../../actions/productDetail';
import * as landingActions from '../../actions/home'
import { Helmet } from "react-helmet";

 
// import custom Components
import RelatedProduct from "./common/similar-products";
import DetailsWithPrice from "./common/product/details-price";
import DetailsTopTabs from "./common/details-top-tabs";
import { addToCartUnsafe } from '../../actions'
import { addToCart } from '../../actions/cart'
import { addToWishlist } from '../../actions/wishlist'
import ImageZoom from './common/product/image-zoom'
import SmallImages from './common/product/small-image'
import FullPageLoader from '../../components/common/fullPageLoader';
import { toast } from 'react-toastify';
// import { mainProductSlider } from '../../services/script'
import { SideBySideMagnifier } from "react-image-magnifiers";
import noImage from '../../assets/images/no-image-available.png';
import noProductImage from '../../assets/images/noProductImg_420x420.jpg'
import DateCountdown from 'react-date-countdown-timer';
class NoSideBar extends Component {

    constructor() {
        super()
        this.state = {
            sizeSelected: [],
            colorSelected: [],
            puritySelected:[],
            nav1: null,
            nav2: null,
            detailPageLoading: true,
            matches: window.matchMedia("(max-width: 991px)").matches,
            tabMatches: window.matchMedia("(max-width: 600px)").matches,
            productLoader: false,
        }
        this.slider1 = React.createRef();
    this.slider2 = React.createRef();
    }

    async componentDidMount() {
        const { getProductDetail,store_details,getAdditionalProductDetail, productDetail, similarProducts, getInfocuItems, match: { params: { id } }, connection_id, user_logged_in_store_id, getProductAddnInfo, categoryId, presentURL} = this.props;
        const options = {
            connection_id,
            lot_code: id,
            tenant_name:store_details && store_details.tenant_name
            // user_logged_in_store_id
        }
        
        
       let products =  await getProductDetail(options);
      if( products === 'success' ){

          await getAdditionalProductDetail(options)}

         localStorage.removeItem('lot_code')
        
        
         this.setState({
            nav1: this.slider1.current,
            nav2: this.slider2.current,
        })
        window.scrollTo(0, 0)
        
        
        

//         var pcode ='';
// if(this.props.categoryData.products.length > 0 && this.props.categoryData.products[0].SKF_PRODUCT_GROUP_CD && this.props.categoryData.products[0].SKF_PRODUCT_GROUP_CD !== undefined){
//     pcode = this.props.categoryData.products[0].SKF_PRODUCT_GROUP_CD
// }
//         const option = {
//             connection_id: connection_id,
//           /*   product_code: id,
//             category_code: categoryId, */
//             product_code: pcode,
//             category_code: this.props.categoryData.products.length > 0 && this.props.categoryData.products[0].SKU_HNODE ? this.props.categoryData.products[0].SKU_HNODE : '',
//         }
//         getProductAddnInfo(option)

    }

   async  componentWillReceiveProps(nextProps) {
        const { getProductDetail,getAdditionalProductDetail, connection_id, productDetail, user_logged_in_store_id,store_details } = this.props;
        if (nextProps.match.params.id !== this.props.match.params.id) {
            const options = {
                connection_id,
                lot_code: nextProps.match.params.id,
                tenant_name:store_details && store_details.tenant_name

               // user_logged_in_store_id
            }
            this.setState({
                sizeSelected: [],
                puritySelected:[]
            })
            


            let products =  await getProductDetail(options);
            if( products === 'success' ){
                await getAdditionalProductDetail(options)}
            //  this.setState({
            //     nav1: this.slider1.current,
            //     nav2: this.slider2.current
            // })
            window.scrollTo(0, 0)


               
              
           
           
        }
        // enable if needed in feature
        // if (nextProps.user_logged_in_store_id !== this.props.user_logged_in_store_id) {
        //     const options = {
        //         connection_id,
        //         lot_code: nextProps.match.params.id,
        //         user_logged_in_store_id
        //     }
        //     getProductDetail(options)
        //     this.setState({
        //         sizeSelected: [],
        //     })
        // }
       
    }

    //sets images to handle color & size variant images
    handleImage = imgsss => {
        this.setState({ image: imgsss });
    }

    handleAddToCart = (item, quantity) => {
        const { presentURL, consumer_mobile_no, Order_type } = this.props;
            // const { connection_id, web_session_trans_id, booking_store_id, consumer_mobile_no } = this.props
            if(consumer_mobile_no){
                const { connection_id, web_session_trans_id, store_details } = this.props
                let booking_storeid = store_details.store_code;
                const options = {
                    connection_id,
                    web_session_trans_id,
                    booking_storeid,
                    consumer_mobile_no,
                    quantity,
                    lot_code: item.QOL_LOT_CD,
                    barcode: item.QOL_EAN_CD,
                    RID_CART_ORDER_TYPE:Order_type,

                }
               if( store_details && store_details.tenant_name == 'Goldiam International Limited')  {
                if (this.state.sizeSelected.length > 0 && this.state.puritySelected.length > 0) {
                    this.props.addToCart(options)
                }
                 else {

                    toast.error( this.state.sizeSelected.length > 0 ? `Select a Purity to proceed.`:`Select a size to proceed.`);
                } 
            }else { 
                if (this.state.sizeSelected.length > 0) {
                    this.props.addToCart(options)
                }
                 else {

                    toast.error( `Select a size to proceed.`);
                }
            }

            }
            else{
                localStorage.setItem('lot_code',this.props.match.params.id)
                toast.error("Please Enter Details to add items to Shopping bag.");
                this.props.history.push('/update');
            }

        
    }

    handleClearSize = () => {
        this.setState({sizeSelected: []})
    }
    handleClearPurity = () => {
        this.setState({puritySelected: []}) 
    }
     handleProductUpdate = async(options,options1) => {
        if(options.sizeReset){
            this.setState({
                sizeSelected: [],
            puritySelected :[]
            })
        } else {
            this.setState({
                sizeSelected: [{
                    SKU_VARIANT2_VALCD: options.size_id,
                    SKU_VARIANT2_VALUE_DESC: options.size_desc
                }],
                puritySelected:[]
               
            })
        }
        if(options.purity_id){
            
            this.setState({  puritySelected: [{
                SKU_VARIANT4_VALCD: options.purity_id,
                SKU_VARIANT4_VALUE_DESC: options.purity_desc
            }] })
        }

let res = await this.props.getProductDetail(options);
if(res === 'success'){
        await this.props.getAdditionalProductDetail(options1);
}
         


        
    }

    handleAddToWishlist = (item,) => {
        if (this.props.isAuth) {
            const { connection_id, consumer_mobile_no } = this.props
            const options = { connection_id, consumer_mobile_no, lot_code: item.QOL_LOT_CD }
            this.props.addToWishlist(options)
        }
        else {
            toast.error("Please login / Register to add items to Wishlist.");
            this.props.history.push('/login');
        }
    }

    componentWillUnmount() {
        
    }

    componentDidUpdate(){

        // if(!this.state.productLoader){
        //     setTimeout(() => {
        //         this.setState({
        //             productLoader: true,
        //         })
        //       },1000)
        // }
    }

    render() {
        const { symbol,pshop_soh_display, productLoadingData, addToWishlist, productLoading, productDetail, productAdditionalInfo, similarProducts, productVariants, completeTheLook, categoryData, productImages, presentURL, tab_enabled_flag,store_details } = this.props
        var productsnav = {
            slidesToShow: 3,
            swipeToSlide: true,
            arrows: false,
            dots: false,
            focusOnSelect: true

        };
        const mainProductSlider = {
            arrows: true,
            infinite: true,
            dots: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
        };
        
        const dates = productDetail.SKF_PRODUCT_LAUNCH_DT;
        if (dates !== null ){
        var dat = new Date(dates); }
        else {
           var dat = null
        }
        if(dat && dat != null)
        {
            var day = dat.toLocaleString('en-us', { weekday: 'long' });
                var date = dat.getDate();
                var year = dat.getFullYear();
                var month = dat.toLocaleString('en-us', { month: 'long' });
        }
        else {
             var date = '';
             var day = '';
             var year ='';
             var month = '';
        }
        
        // if (productImages.length > 0) {
        //     return (
        //         <div>
        //             <div className="product-wrapper-grid">
        //                 <div className="container-fluid">
        //                     <div className="loading-cls"></div>
        //                 </div>
        //             </div>
        //         </div>
        //     )
        // }

        // if(!this.state.productLoader){
        //     return (
        //         <div>
        //             <div className="product-wrapper-grid">
        //                 <div className="container-fluid">
        //                     <div className="loading-cls"></div>
        //                 </div>
        //             </div>
        //         </div>
        //     )
        //     }

        const initialColor  = productVariants.length > 0 && productVariants.find( item => 
            item.SKU_VARIANT1_VALCD ===  productDetail.SKU_VARIANT1_VALCD
        )|| []
        
        let allProductImages = []
        var MainImage = {PIM_IMAGE_FILE_NAME : noProductImage};
        if(productDetail){
            {productDetail.SKU_IMAGE && productDetail.SKU_IMAGE.length > 45 && productDetail.SKU_IMAGE !== '\/images\/noProductImg_45x45.jpg' ? 

            MainImage = {PIM_IMAGE_FILE_NAME: productDetail.SKU_IMAGE} : 
        MainImage = {PIM_IMAGE_FILE_NAME : noProductImage}}
            
            allProductImages = [MainImage]
            if(productImages.original){
                allProductImages = [MainImage,...productImages.original]
            }
        }

        
        // if(localStorage.getItem('selectedImage') !== null && localStorage.getItem('selectedImage')){
        //     var loc = {'PIM_IMAGE_FILE_NAME':localStorage.getItem('selectedImage')}
        //     allProductImages.unshift(loc)
        //     allProductImages = Array.from(new Map(allProductImages.map(item => [item.PIM_IMAGE_FILE_NAME, item])).values());
        // }
        return (
            <div>
                {/* {!productLoading ? */}
                <Helmet>
                    <title>{this.props.customer_name}  | Product </title>
                    <meta name="description" content="mango store" />
                </Helmet>
                <section style={{paddingTop:10}}>
                    <div className="collection-wrapper" style={{marginBottom:60}}>
                        <div className="container">
                            <div className="row">
                                <div className={dat === null ? "col-lg-6 product-thumbnail" : "col-lg-4 product-thumbnail" }>
                                    <Slider {...mainProductSlider} asNavFor={this.state.nav2} ref={this.slider1} className="product-slick">
                                        {!productLoading && allProductImages.length> 0 &&
                                            allProductImages.map((item, index) => {
                                                return (
                                                    <div key={index} className="input-position">
                                                        {
                                                            !this.state.tabMatches 
                                                            ?
                                                                <SideBySideMagnifier 
                                                                    imageSrc={item.PIM_IMAGE_FILE_NAME}
                                                                    imageAlt={item.PIM_IMAGE_FILE_NAME}
                                                                    alwaysInPlace={true}
                                                                    overlayBoxOpacity={0.4}
                                                                    className="img-fluid product-page-img"
                                                                />
                                                            :
                                                            <ImageZoom productLoading={productLoading} image={item.PIM_IMAGE_FILE_NAME} className="img-fluid image_zoom_cls-0" />

                                                        }
                                                        
                                                    </div>
                                                )
                                            })
                                        }
                                    </Slider>
                                    {/* {localStorage.removeItem('selectedImage')} */}
                                    <br/>
                                   {/*  {this.state.matches && !productLoading && productImages && productImages.original &&
                                    <SmallImages item={allProductImages} settings={productsnav} navOne={this.state.nav1} productLoading={productLoading} />
                                     } */}
                                       {/* Thumbnail Images */}
                                       {
                   !this.props.matches && !productLoadingData && productImages && productImages.original && 
                    <SmallImages lot_code ={this.props.match.params.id}  item={allProductImages} settings={productsnav} navOne={this.state.nav1} productLoading={productLoadingData} slider2={this.slider2} />
                    }
                    
                    {/* end Thumbnail Images */}
                                </div>
                                {/* <div className="col-lg-1 product-thumbnail" style={{paddingRight: 0, paddingLeft: 0}}></div> */}
                                {!productLoading ?
                                    <DetailsWithPrice symbol={symbol}
                                        connection_id={this.props.connection_id}
                                        lot_code={this.props.match.params.id}
                                        item={productDetail}
                                        dat = {dat}
                                        pshop_soh_display = {pshop_soh_display}
                                        sizeSelected={this.state.sizeSelected}
                                        puritySelected={this.state.puritySelected}
                                        store_details = {store_details}
                                        
                                        // colorSelected={productDetail}
                                        colorSelected={[initialColor]}
                                        productLoading
                                        // onSelectSize={this.handleImage}
                                        handleClearSize={this.handleClearSize}
                                        handleClearPurity={this.handleClearPurity}
                                        itemVariants={productVariants}
                                        addToCartClicked={this.handleAddToCart}
                                        addToWishlistClicked={this.handleAddToWishlist}
                                        handleProductUpdate={this.handleProductUpdate} 
                                        productLoadingData={productLoading}
                                        allProductImages={allProductImages}
                                        productsnav={productsnav}
                                        nav1={this.state.nav1}
                                        productImages={productImages}
                                        productAdditionalInfo={productAdditionalInfo} 
                                        presentURL={presentURL}
                                        matches={this.state.matches}
                                        />
                                    : <FullPageLoader />
                                }
            <div className="col-lg-3 rtl-text">
                {dat && dat != null ?
                
            <div className='border' style={{padding:3,textAlignLast:"center",paddingBottom:20,paddingTop:20}}>
                <div className=' row' style={{width:'90%',margin:'auto'}}><div className='col' style={{padding:5}}><b>Available On</b></div>
                </div><div  className='row'><div className='col' style={{padding:5}}><b>{day} {date},{month} {year}</b></div></div>
             <br/>
                <DateCountdown dateTo={dat}  noAnimate='true' locales_plural={['years','months','Days','hours','Mins','Secs']} />
            <br/>
           {/*  <div className='preorder-price'>PreOrder Price : {symbol}200 </div>
            <br/>
            */}
            <br/>
             <div><button className='btn preorder-button'>PreOrder</button></div>
            </div>
            : '' }
{/* <div>
                                 <div className='container border' >
                        <div className='row' style={{height:40}}>
                            <div className='col-1'>
<a href='#' className='ic1'></a>
                            </div>
                            <div className='col'>
                                <h5>Free shipping</h5>
                                <p>Free shipping world wide</p>
                            </div>

                        </div>
                        <hr/>
                        <div className='row' style={{height:50}}>
                            <div className='col-1'>

                            </div>
                            <div className='col'>
                                <h5>24 X 7 Service</h5>
                                <p>Online service for New Customer</p>
                            </div>

                        </div><hr/> <div className='row' style={{height:50}}>
                            <div className='col-1'>
                            <a href='#' className='ic2'></a>

                            </div>
                            <div className='col'>
                                <h5>Festival Offer </h5>
                                <p>New Online Special festeval offers</p>
                            </div>

                        </div><hr/> <div className='row' style={{height:70}}>
                            <div className='col-1'>
                            <a href='#' className='ic3'></a>

                            </div>
                            <div className='col'>
                                <h5>Online payment</h5>
                                <p>Online service for New Customer</p>
                            </div>

                        </div>
                        
                    </div>
                    <hr/>
                    <div className='container' style={{paddingBottom:10}}>
                        <div className='row'>
                            <div className='col'>
                            <img style={{height:126}} src=" https://du2zkqqqvnrs.cloudfront.net/live/tenant_cdn_content/E1708013/prod_catalog/image/1000x1000/67020048_15.jpg" alt="" class="img-fluid" />
                            </div>
                            <div className='col' style={{marginLeft:-27,marginTop:30}}>
                                <div>T-Shirt Mangofi-H<br/>
                                ₹890.00</div>

                            </div>
                        </div>
                    </div> 
                    </div> */} 
                    
                    
                    
                    </div>
                            </div>
                            <div className='row' style={{padding:"0px 20px 20px 20px" }}><div className='col-sm-12'>
                    <div className="border-product" style={{ border: "none",paddingTop:10 }}>
                        <h5  className="product-title" style={{ fontSize: 14,textAlign:'center' }}>DESCRIPTION</h5>
                        <div style={{textAlign:'justify',lineHeight:'20px'}}>{productDetail.SKF_PRODUCT_GROUP_DESC}</div>
                    </div></div></div>
                        </div>

                    </div>
                </section>
                {productDetail && productAdditionalInfo ?
                    <section className="tab-product m-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12 col-lg-12">
                                    <DetailsTopTabs 
                                    item={productDetail} 
                                    productAdditionalInfo={productAdditionalInfo} 
                                    tab_enabled_flag={tab_enabled_flag}
                                    />
                                </div>
                            </div>
                        </div>
                    </section>
                    : null}
                { this.props.similarProducts.length > 0 ?
                    <RelatedProduct 
                        connection_id={this.props.connection_id}
                        consumer_mobile_no={this.props.consumer_mobile_no}
                        items={similarProducts} type={'women'} 
                        presentURL={presentURL}
                    /> 
                : null}
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    symbol: state.data.symbol,
    productLoading: state.productDetail.loading,
    productDetail: state.productDetail.productDetail || null,
    // productVariants: state.productDetail.productVariants,
    productImages: state.productDetail.productImages,
    completeTheLook: state.productDetail.completeTheLook||[],
    similarProducts: state.productDetail.similarProducts||[],
    tab_enabled_flag: state.productDetail.tab_enabled_flag,
    pshop_soh_display : state.productDetail.pshop_soh_display,
    user_logged_in_store_id: state.store.selectedStore && state.store.selectedStore.ASM_ASSOC_CD,
    collections: state.landing.collections,
    categoryData: state.category,
    connection_id: state.tenant.connection_id,
    isAuth: state.user.isAuth,
    web_session_trans_id: state.user.user_details && state.user.web_session_trans_id,
    booking_store_id: state.store.selectedStore && state.store.selectedStore.ASM_ASSOC_CD,
    consumer_mobile_no: state.user.user_details && state.user.user_details.COM_CONSUMER_MOBILE_NO,
    customer_name: state.tenant.tenant_details.STE_ECOM_BRAND_NAME || "",
    productAdditionalInfo: state.productDetail.additionalInfo,
    productVariants:  state.productDetail.variants,
    categoryId: ownProps.match.params.id,
    presentURL: state.tenant.presentURL,
    store_details: state.tenant.store_details,
    Order_type: state.tenant.Order_type,
})

const mapDispatchToProps = dispatch => bindActionCreators({
    getProductDetail,
    getAdditionalProductDetail,
    addToCart,
    addToCartUnsafe,
    addToWishlist,
    getProductAddnInfo,
    getInfocuItems: landingActions.getInfocusItems
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(NoSideBar);

